import rickySheet from '../assets/ricky/ricky-morgan-character-sheet.jpg';

export default function RickyMorgan() {
  return (
    <figure className="ricky-morgan relative mx-auto w-full max-w-[17rem] lg:max-w-[21rem]" aria-label="Ricky Morgan, Relate.ai spokesperson visual">
      {/* Future animation: Ricky Morgan entrance / subtle parallax */}
      <div className="absolute -inset-5 rounded-[3rem] bg-gradient-to-br from-white via-violet-100/60 to-rose-100/80 blur-2xl" aria-hidden="true" />
      <div className="relative overflow-hidden rounded-[2.5rem] border border-white/80 bg-white/70 shadow-soft backdrop-blur-2xl">
        <div
          role="img"
          aria-label="Ricky Morgan in a white suit, Relate.ai spokesperson"
          className="aspect-[4/5] w-full bg-white bg-no-repeat"
          style={{
            backgroundImage: `url(${rickySheet})`,
            backgroundSize: '315%',
            backgroundPosition: '39% 54%',
          }}
        />
        <figcaption className="absolute bottom-4 left-4 right-4 rounded-2xl border border-white/70 bg-white/76 px-4 py-3 text-left text-xs font-semibold text-slate-600 shadow-glass backdrop-blur-xl">
          <span className="block text-sm font-extrabold text-slate-950">Ricky Morgan</span>
          AI spokesperson / visual guide
        </figcaption>
      </div>
    </figure>
  );
}
